import { useMemo } from 'react';
import { usePatientVirtualAppointments } from '../../../../hooks/useVirtualAppointments';
import {
    countCanceledOnDelete,
    documentDeleteVaNotice,
    type DocumentDeleteVaState
} from './documentDeleteVaNotice';

// Cached VAs show at once; the fresh read corrects the count when it lands.
export function useDocumentDeleteVaNotice(patientId: string, groupId: string): string | null {
    const { data, isError, isFetching } = usePatientVirtualAppointments(
        patientId,
        { groupId },
        { fresh: true }
    );
    return useMemo(() => {
        const state: DocumentDeleteVaState = data
            ? { kind: 'ready', count: countCanceledOnDelete(data) }
            : isError && !isFetching
              ? { kind: 'error' }
              : { kind: 'loading' };
        return documentDeleteVaNotice(state);
    }, [data, isError, isFetching]);
}
